import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { get } from '../../utils/api'
import { useUser } from '../../context/AuthContext'
import './GRIHeader.css'

const GRIHeader = () => {
  const { id } = useParams()
  const { user: companyDetails } = useUser()
  const [orgData, setOrgData] = useState(null)

  useEffect(() => {
    fetchData()
  }, [id])

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GeneralDisclosures2021`)
      const orgDetails = res?.data?.data?.GeneralDisclosures2021?.orgDetails
      
      setOrgData(orgDetails)
    } catch (err) {
      console.log('Error fetching GRI data:', err)
    }
  }

  // Format headquarters address
  const formatHeadquarters = () => {
    if (!orgData?.headQuaters) return ''
    const hq = orgData.headQuaters
    const parts = [
      hq.address1,
      hq.address2,
      hq.state,
      hq.pinCode ? `- ${hq.pinCode}` : '',
      hq.country
    ].filter(Boolean)
    return parts.join(', ')
  }

  // Format countries of operation
  const formatCountries = () => {
    if (!orgData?.countries || orgData.countries.length === 0) return 'India'
    return orgData.countries.map(c => c.country || c.additionalDetails).filter(Boolean).join(', ') || 'India'
  }

  return (
    <div className="gri-header-container">
      {/* Section 1: ORGANIZATIONAL DETAILS - Green Box */}
      <div className="gri-header-green-box">
        <h2 className="gri-header-title">
          ORGANIZATIONAL DETAILS
        </h2>

        <div className="gri-header-content">
          <div className="gri-header-row">
            <span className="gri-header-value">
              Legal name of the organization:{' '}
            </span>
            <span className="gri-header-label">
              {orgData?.name || companyDetails?.company?.companyName || 'Nirantara Ecoventures Private Limited'}
            </span>
          </div>

          <div className="gri-header-row">
            <span className="gri-header-value">
              Ownership Type:{' '}
            </span>
            <span className="gri-header-label">
              {orgData?.ownerShipType || 'Privately Owned'}
            </span>
          </div>

          <div className="gri-header-row">
            <span className="gri-header-value">
              Legal form of the organization:{' '}
            </span>
            <span className="gri-header-label">
              {orgData?.legalForm || 'Incorporated Entity'}
            </span>
          </div>

          <div className="gri-header-row">
            <span className="gri-header-value">
              Location of headquarters of the organization:{' '}
            </span>
            <span className="gri-header-label">
              {formatHeadquarters() || 'World Trade Centre, Kharadi, Pune, Maharashtra - 410047'}
            </span>
          </div>

          <div className="gri-header-row">
            <span className="gri-header-value">
              Countries of operation:{' '}
            </span>
            <span className="gri-header-label">
              {formatCountries()}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GRIHeader
